import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { AUTH_LOGIN_ERROR, AUTH_LOGIN_REQUEST, AUTH_LOGIN_SUCCESS, AUTH_IDENTIFY_SUCCESS } from '../types';
import { assignCurrentCart } from '../cart';
import { loadUser } from '../user/load-user';
export var loginRequest = function loginRequest(email) {
  return {
    type: AUTH_LOGIN_REQUEST,
    payload: {
      email: email
    }
  };
};
export var loginSuccess = function loginSuccess(payload) {
  return {
    type: AUTH_LOGIN_SUCCESS,
    payload: payload
  };
};
export var loginError = function loginError(error) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: AUTH_LOGIN_ERROR,
    error: true,
    meta: meta,
    payload: {
      error: error
    }
  };
};
var identifySuccess = function identifySuccess(token) {
  return {
    type: AUTH_IDENTIFY_SUCCESS,
    payload: {
      token: token
    }
  };
};
export var login = function login(options) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, _getState, _ref) {
      var auth, email, _options$showUI, showUI, _options$redirectURI, redirectURI, token, metadata;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            email = options.email, _options$showUI = options.showUI, showUI = _options$showUI === void 0 ? false : _options$showUI, _options$redirectURI = options.redirectURI, redirectURI = _options$redirectURI === void 0 ? window.location.href : _options$redirectURI;
            _context.prev = 2;
            dispatch(loginRequest(email));
            _context.next = 6;
            return auth.login({
              email: email,
              showUI: showUI,
              redirectURI: redirectURI
            });
          case 6:
            _context.next = 8;
            return auth.getToken();
          case 8:
            token = _context.sent;
            dispatch(identifySuccess(token));
            _context.next = 12;
            return auth.getUser();
          case 12:
            metadata = _context.sent;
            dispatch(loginSuccess({
              email: metadata.email,
              token: token
            }));
            // Fetch the user from the OMS, now that we have logged in
            _context.next = 16;
            return dispatch(loadUser());
          case 16:
            _context.next = 22;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](2);
            dispatch(loginError(_context.t0, {
              email: email,
              showUI: showUI,
              redirectURI: redirectURI
            }));
            throw _context.t0;
          case 22:
            _context.prev = 22;
            _context.next = 25;
            return dispatch(assignCurrentCart());
          case 25:
            _context.next = 30;
            break;
          case 27:
            _context.prev = 27;
            _context.t1 = _context["catch"](22);
            console.error('Error associating cart with user', _context.t1);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 18], [22, 27]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};